import { render } from "./PlatformAgreement.vue?vue&type=template&id=39556148&scoped=true&ts=true"
import script from "./PlatformAgreement.vue?vue&type=script&lang=ts"
export * from "./PlatformAgreement.vue?vue&type=script&lang=ts"

import "./PlatformAgreement.vue?vue&type=style&index=0&id=39556148&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39556148"]])

export default __exports__